export default __webpack_public_path__ + "static/media/icon-active-location.e89d4bda.svg";